const RequestAboutPhysica = ({
    handleChooseTherapistClick,
    setShowMore,
    showMore,
     pinCode,
  }) => {
    return (
      <div className="AboutPhysica">
        <div className="flex flex-col text-[#2C3776] font-semibold">
          <h1 className="text-2xl">Available Slots in {pinCode || "your Area"}</h1>
        </div>
      </div>
    );
  };
  
  export default RequestAboutPhysica;
  